module.exports = __webpack_public_path__ + "img/rating.0aafb10d.png";